"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @module parjs/internal/implementation/combinators
 */
/** */
const action_1 = require("../../action");
const reply_1 = require("../../../../reply");
const special_results_1 = require("../../special-results");
const errors_1 = require("../../../../errors");
class PrsMaybe extends action_1.ParjsAction {
    constructor(_inner, _val) {
        super();
        this._inner = _inner;
        this._val = _val;
        if (_val !== special_results_1.QUIET_RESULT && !_inner.isLoud) {
            throw new errors_1.ParserDefinitionError("altVal", "the inner parser must be loud if an alternative value is supplied.");
        }
        else if (_inner.isLoud && _val === special_results_1.QUIET_RESULT) {
            throw new errors_1.ParserDefinitionError("altVal", "the inner parser must be quiet if an alternative value is not supplied.");
        }
        this.isLoud = _inner.isLoud;
        this.expecting = `${_inner.expecting} or anything`;
    }
    _apply(ps) {
        let { _inner, _val } = this;
        _inner.apply(ps);
        if (ps.isSoft) {
            //on soft failure, set the value and result to OK
            if (this.isLoud)
                ps.value = _val;
            ps.kind = reply_1.ReplyKind.Ok;
        }
        //on ok/hard/fatal, propagate the result.
    }
}
exports.PrsMaybe = PrsMaybe;
//# sourceMappingURL=alt-val.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/parjs/internal/implementation/combinators/alternatives/alt-val.js
// module id = 905
// module chunks = 0 1